import { render } from "./PwaInstructions.vue?vue&type=template&id=4df488c4&scoped=true"
import script from "./PwaInstructions.vue?vue&type=script&lang=js"
export * from "./PwaInstructions.vue?vue&type=script&lang=js"

import "./PwaInstructions.vue?vue&type=style&index=0&id=4df488c4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4df488c4"

export default script